export enum ParentCaregiverRoles {
  'Parent and caregiver' = 'parent and caregiver',
  'Parent (not a caregiver)' = 'parent',
  'Caregiver (not parent)' = 'caregiver',
}

export enum ParentMaritalStatus {
  'Married' = 'married',
  'Divorced' = 'divorced',
  'Single' = 'single',
  'Domestic partnership' = 'domestic partnership',
}

export enum EducationSettings {
  'Homeschool' = 'Homeschool',
  'In-person public/private' = 'In-person public/private',
  'Remote' = 'Remote',
  'Not specified' = 'Not specified',
}

export enum EducationEvaluations {
  'Request was made during initial assessment to obtain copies of any academic evaluations and/or assessments previously conducted.' = 'Request was made during initial assessment to obtain copies of any academic evaluations and/or assessments previously conducted.',
  'Parent/Guardian provided academic evaluations and/or assessments for intake which were reviewed and considered.' = 'Parent/Guardian provided academic evaluations and/or assessments for intake which were reviewed and considered.',
  'No academic evaluations and/or assessments were completed.' = 'No academic evaluations and/or assessments were completed.',
}

export enum MemberLanguages {
  English = 'english',
  Spanish = 'spanish',
  French = 'french',
  Portuguese = 'portuguese',
  Mandarin = 'mandarin',
  Japanese = 'japanese',
  Other = 'other',
  Null = '',
}
